exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-tour-template-js": () => import("./../../../src/templates/tour-template.js" /* webpackChunkName: "component---src-templates-tour-template-js" */)
}

